/* Elite Rentals: consent-gated WhatsApp quote clicks, not sales or reservations. */
(function () {
  'use strict';
  if (window.__eliteWhatsAppMeasurementInstalled) return;
  window.__eliteWhatsAppMeasurementInstalled = true;

  var tagId = 'AW-18498112399';
  var sendTo = 'AW-18498112399/DtFICLj-y5MdEI-Xy_RE';
  var configured = false;
  var consentGeneration = 0;
  var handledEvents = new WeakSet();

  function permitted() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
      var consent = privacy.currentVisitorConsent();
      return consent.marketing === 'yes' && consent.analytics === 'yes' &&
        consent.sale_of_data !== 'no' &&
        privacy.marketingAllowed() === true &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.saleOfDataAllowed() === true &&
        navigator.globalPrivacyControl !== true;
    } catch (_) {
      return false;
    }
  }

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function safeParameters() {
    // Use constants: never inspect forms, link text, WhatsApp query or referrer.
    return {
      send_to: sendTo,
      page_location: 'https://elitex1.com/',
      page_referrer: '',
      page_title: 'Elite Rentals',
      user_data: {},
      allow_enhanced_conversions: false,
      allow_ad_personalization_signals: false
    };
  }

  function sendNow(generation) {
    if (generation !== consentGeneration || !permitted()) return;
    if (!configured) {
      gtag('config', tagId, {
        send_page_view: false,
        groups: 'elitequote',
        page_location: 'https://elitex1.com/',
        page_referrer: '',
        page_title: 'Elite Rentals',
        user_data: {},
        allow_enhanced_conversions: false,
        allow_ad_personalization_signals: false
      });
      configured = true;
    }
    gtag('event', 'conversion', safeParameters());
  }

  function googleScriptPresent() {
    // Reuse the existing Shopify Google app loader; never duplicate it.
    return Array.prototype.some.call(document.scripts, function (script) {
      if (!script.src) return false;
      try {
        var url = new URL(script.src, document.baseURI);
        return url.hostname === 'www.googletagmanager.com' && url.pathname === '/gtag/js';
      } catch (_) { return false; }
    });
  }

  function measure() {
    // The installed Shopify Google app owns the shared consent bridge and
    // loader. If it is absent, fail closed instead of creating a second one.
    if (!permitted() || typeof window.gtag !== 'function' || !googleScriptPresent()) return;
    sendNow(consentGeneration);
  }

  document.addEventListener('visitorConsentCollected', function () {
    // Never replay a click made before consent or after refusal/revocation.
    consentGeneration += 1;
  });

  document.addEventListener('click', function (event) {
    // Bubble phase runs after the product's capture-phase date validation.
    if (!event.isTrusted || event.defaultPrevented || event.button !== 0 || handledEvents.has(event)) return;
    var target = event.target;
    var anchor = target && target.closest ? target.closest('a[href]') : null;
    if (!anchor || anchor.hasAttribute('download') || anchor.getAttribute('data-rental-valid') === 'false') return;
    try {
      var destination = new URL(anchor.getAttribute('href'), document.baseURI);
      if (destination.protocol !== 'https:' || destination.hostname !== 'wa.me' ||
          destination.pathname !== '/13527345835' || destination.username || destination.password || destination.port) return;
    } catch (_) { return; }
    handledEvents.add(event);
    measure();
    // Native navigation is preserved, including mobile app / desktop web handoff.
  }, false);

  // Shopify's consent API is first-party and has no Google tracking request.
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
})();
